import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from 'src/environments/environment';
import {Note} from '../models/note.model';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NoteService {

  private url = environment.url;

  constructor(private http: HttpClient) {
  }

  createApprovalPathNote(note: string, id: number) {
    return this.http.post(this.url + 'approvalPath/' + id + '/notes', {text: note});
  }

  fetchCostNotes(id: number) {
    return this.http.get<Note[]>(this.url + 'cost/' + id + '/notes').pipe(
      map(v => v.map(Note.adapt))
    );
  }
}
